export default __webpack_public_path__ + "static/media/truck-transporter-icon.ba1b9c17.svg";